<!-- Left: Info sections (stacked vertically) -->
<div class="upgrade-info-column">
  <!-- 1. BASIC INFO -->
  <ion-grid
    class="upgrade-section upgrade-section-soft body-3 text-grey-400 bg-accent-100"
    fixed>
    <ng-container *ngTemplateOutlet="label; context: { label: _labels.basicInfo }"></ng-container>
    <ion-row class="ion-justify-content-around">
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-label">
          {{ _labels.serial }}
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-value">
          {{ serial }}
          <ion-skeleton-text
            *ngIf="!serial"
            animated
            class="w-full">
          </ion-skeleton-text>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- 2. CURRENT VERSION INFO -->
  <ion-grid
    class="upgrade-section upgrade-section-soft body-3 text-grey-400 bg-accent-100"
    fixed>
    <ng-container *ngTemplateOutlet="label; context: { label: _labels.currentVersionInfo }"></ng-container>

    <!-- Logger: single row -->
    <ng-container *ngIf="deviceType === 'logger'">
      <ion-row class="ion-justify-content-around">
        <ion-col size="6">
          <div class="fx-col fx-center p-3 border-box kv-cell kv-label">
            {{ _labels.moduleVersionNo }}
          </div>
        </ion-col>
        <ion-col size="6">
          <div class="fx-col fx-center p-3 border-box kv-cell kv-value">
            {{ moduleVersionString }}
            <ion-skeleton-text
              *ngIf="!moduleVersionString"
              animated
              class="w-full">
            </ion-skeleton-text>
          </div>
        </ion-col>
      </ion-row>
    </ng-container>

    <!-- Inverter: multiple rows -->
    <ng-container *ngIf="deviceType === 'inverter'">
      <ion-row
        *ngIf="!moduleVersionList?.length"
        class="ion-justify-content-around">
        <ion-col size="12">
          <ion-skeleton-text
            animated
            class="w-full fx-col fx-center p-3 border-box">
          </ion-skeleton-text>
        </ion-col>
      </ion-row>
      <ion-row
        *ngFor="let mv of moduleVersionList"
        class="ion-justify-content-around">
        <ion-col size="6">
          <div class="fx-col fx-center p-3 border-box kv-cell kv-label text-center">
            {{ mv.key }}
          </div>
        </ion-col>
        <ion-col size="6">
          <div class="fx-col fx-center p-3 border-box kv-cell kv-value text-center">
            {{ mv.value }}
          </div>
        </ion-col>
      </ion-row>
    </ng-container>
  </ion-grid>

  <!-- 3. LAST UPGRADE RECORD (only if lastAction) -->
  <ion-grid
    *ngIf="lastAction"
    class="upgrade-section body-3 text-grey-400"
    fixed
    [ngClass]="{
      'bg-red-100': lastAction.error,
      'bg-blue-100': isUpgrading,
      'bg-green-100': lastAction.status === 666
    }">
    <ng-container *ngTemplateOutlet="label; context: { label: _labels.lastUpgradeRecord }"></ng-container>
    <ion-row class="ion-justify-content-around">
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-label">
          {{ _labels.versionKeyName }}
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-value text-center">
          {{ lastAction.versionKeyName }}
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-around">
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-label">
          {{ _labels.targetVersion }}
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-value">
          <span class="version-badge version-latest">{{ lastAction.version }}</span>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-around">
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-label">
          {{ _labels.upgradeTime }}
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-value">
          {{ lastAction.createTime | date: 'yyyy-MM-dd HH:mm:ss' }}
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="isUpgrading"
      class="ion-justify-content-around">
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-label">
          {{ _labels.progress }}
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-value">
          <span class="text-semi-bold">{{ lastAction.currentProgress }}%</span>
          <ion-progress-bar
            class="tw-mt-2 w-full"
            [value]="getUpgradeProgress(lastAction.currentProgress)">
          </ion-progress-bar>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-around">
      <ion-col size="6">
        <div class="fx-col fx-center p-3 border-box kv-cell kv-label">
          {{ _labels.status }}
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="fx-row fx-center p-3 border-box kv-cell kv-value">
          <span
            *ngIf="lastAction.error; else status"
            class="status-error pl-3 text-justify">
            <strong class="pr-3">{{ _labels.error }}</strong>
            <span [innerHTML]="FirmwareUpdateErrorDescription[lastAction.error]"></span>
          </span>
          <ng-template #status>
            <span
              class="status-pill"
              [ngClass]="{
                'status-pill-success': lastAction.status === 666,
                'status-pill-progress': isUpgrading
              }">
              {{ lastAction.status === 666
                ? _labels.success
                : isUpgrading
                  ? _labels.upgrading
                  : _labels.terminated }}
            </span>
          </ng-template>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>

<!-- Right: Upgrade Request -->
<div class="upgrade-request-column">
  <!-- Loading state -->
  <ion-grid
    *ngIf="!hasFirmwareData"
    class="upgrade-section body-3 text-grey-400">
    <ng-container *ngTemplateOutlet="label; context: { label: _labels.upgradeRequest }"></ng-container>
    <ion-row class="ion-justify-content-around">
      <ion-col size="12">
        <ion-skeleton-text
          animated
          class="w-full fx-col fx-center p-3 border-box tw-h-10">
        </ion-skeleton-text>
      </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-around">
      <ion-col size="12">
        <ion-skeleton-text
          animated
          class="w-full fx-col fx-center p-3 border-box tw-h-[120px]">
        </ion-skeleton-text>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Firmware loaded -->
  <ion-grid
    *ngIf="hasFirmwareData"
    class="upgrade-section body-3 text-grey-400"
    [ngClass]="{
      'bg-green-100': isConnected,
      'bg-red-100': !isConnected
    }">
    <ng-container *ngTemplateOutlet="label; context: { label: _labels.upgradeRequest }"></ng-container>
    <ng-container *ngIf="isConnected; else offline">
      <ng-container *ngIf="isUpgrading; else noCurrentUpgrading">
        <ion-col size="12">
          <div class="fx-col fx-center p-3 border-box body-2 text-semi-bold text-grey-500">
            {{ _labels.currentUpgrading }}
          </div>
        </ion-col>
      </ng-container>
      <ng-template #noCurrentUpgrading>
        <ion-row class="ion-justify-content-around">
          <ion-card-content class="tw-px-3 w-full">
            <div class="section-card bg-white radius-4 tw-mb-4 tw-p-3">
              <p class="body-4 text-grey-300 tw-uppercase tw-mb-1 text-semi-bold">{{ detectionLabel }}</p>
              <p
                *ngIf="detectedType"
                class="body-2 text-accent text-semi-bold detected-type">
                {{ detectedType }}
              </p>
              <p
                *ngIf="!detectedType"
                class="body-4 text-grey-300 tw-italic">
                {{ unableToDetectLabel }}
              </p>
            </div>
            <div
              *ngIf="availableTags.length"
              class="section-card bg-white radius-4 tw-mb-4 tw-p-3">
              <p class="body-4 text-grey-300 tw-uppercase tw-mb-2 text-semi-bold">{{ _labels.filterByTags }}</p>
              <div class="tw-flex tw-flex-wrap tw-gap-2">
                <ion-chip
                  *ngFor="let tag of availableTags"
                  class="tw-m-0"
                  [style.--background]="isFilterTagActive(tag) ? 'var(--accent-100)' : 'var(--grey-100)'"
                  [style.--color]="isFilterTagActive(tag) ? 'var(--accent)' : 'var(--grey-400)'"
                  (click)="toggleFilterTag(tag)">
                  <ion-label [class.tw-italic]="isCustomTag(tag)">{{ tag }}</ion-label>
                </ion-chip>
              </div>
            </div>
            <customer-search
              class="tw-mb-4"
              [placeholder]="_labels.searchPlaceholder"
              [query]="searchQuery"
              (clearQuery)="onVersionClearQuery()"
              (queryChange)="onVersionQueryChange($event)">
            </customer-search>
            <ion-list class="firmware-list overflow-y-auto max-h-75">
              <div
                *ngIf="filteredVersionList?.length === 0"
                class="firmware-empty-state tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8 tw-px-4 text-grey-300">
                <ion-icon
                  class="tw-text-4xl tw-mb-2"
                  name="search-outline"></ion-icon>
                <p class="body-2 tw-text-center">{{ _labels.noFirmwareFound }}</p>
                <p class="body-4 tw-text-center tw-mt-1">{{ _labels.tryAdjustingFilters }}</p>
              </div>
              <ion-item
                *ngFor="let version of filteredVersionList"
                class="firmware-item tw-mb-2"
                [class.selected]="selectedVersion?.name === version.name"
                (click)="selectVersionItem(version)">
                <ion-label class="firmware-item-surface bg-grey-100 radius-4 tw-px-3 tw-py-2">
                  <div class="body-2 text-grey-500 tw-mb-1 ellipsed">
                    {{ getDisplayName(version) }}
                  </div>
                  <p class="body-4 text-grey-300 tw-mb-2">
                    <span class="version-badge version-current tw-font-mono">{{ version.version }}</span>
                  </p>
                  <div
                    *ngIf="version.metadata?.tags?.length"
                    class="tw-flex tw-flex-wrap tw-gap-1">
                    <ion-chip
                      *ngFor="let tag of version.metadata?.tags"
                      class="tw-m-0 tw-h-6"
                      [style.--background]="isFilterTagActive(tag) ? 'var(--accent-100)' : 'var(--grey-100)'"
                      [style.--color]="isFilterTagActive(tag) ? 'var(--accent)' : 'var(--grey-400)'"
                      (click)="$event.stopPropagation(); toggleFilterTag(tag)">
                      <ion-label
                        class="tw-text-xs"
                        [class.tw-italic]="isCustomTag(tag)">{{ tag }}</ion-label>
                    </ion-chip>
                  </div>
                </ion-label>
              </ion-item>
            </ion-list>
            <div
              *ngIf="selectedVersion"
              class="selected-firmware-card radius-4 tw-p-4 tw-mt-4 bg-white">
              <h2 class="tw-mb-3 body-1 text-accent tw-text-center text-semi-bold">{{ _labels.selectedFirmware }}</h2>
              <div class="tw-space-y-2">
                <p>
                  <strong class="text-grey-400 tw-inline-block tw-w-28">{{ _labels.name }}</strong>
                  <span class="text-grey-500 tw-whitespace-pre-wrap">{{ getDisplayName(selectedVersion) }}</span>
                </p>
                <p>
                  <strong class="text-grey-400 tw-inline-block tw-w-28">{{ _labels.version }}</strong>
                  <span class="version-badge version-latest text-grey-500 tw-font-mono">{{ selectedVersion.version }}</span>
                </p>
                <p *ngIf="selectedVersion.metadata?.releaseDate">
                  <strong class="text-grey-400 tw-inline-block tw-w-28">{{ _labels.releaseDate }}</strong>
                  <span class="text-grey-500">{{ selectedVersion.metadata?.releaseDate | date: 'yyyy-MM-dd HH:mm' }}</span>
                </p>
                <p *ngIf="selectedVersion.metadata?.notes">
                  <strong class="text-grey-400 tw-inline-block tw-w-28">{{ _labels.notes }}</strong>
                  <span class="text-grey-500 tw-whitespace-pre-wrap">{{ selectedVersion.metadata?.notes }}</span>
                </p>
              </div>
              <div
                *ngIf="selectedVersion.metadata?.tags?.length"
                class="tw-mt-3 tw-pt-3 tw-border-t tw-border-grey-200">
                <p class="body-4 text-grey-300 tw-uppercase tw-mb-2 text-semi-bold">{{ _labels.tags }}</p>
                <div class="tw-flex tw-flex-wrap tw-gap-1">
                  <ion-chip
                    *ngFor="let tag of selectedVersion.metadata?.tags"
                    class="tw-m-0"
                    [style.--background]="isFilterTagActive(tag) ? 'var(--accent-100)' : 'var(--grey-100)'"
                    [style.--color]="isFilterTagActive(tag) ? 'var(--accent)' : 'var(--grey-400)'"
                    (click)="toggleFilterTag(tag)">
                    <ion-label [class.tw-italic]="isCustomTag(tag)">{{ tag }}</ion-label>
                  </ion-chip>
                </div>
              </div>
            </div>
            <ion-row class="timeout-row ion-justify-content-around bg-white radius-4 tw-mt-4">
              <ion-col size="4">
                <div class="fx-col fx-center p-3 border-box text-semi-bold kv-label">
                  {{ _labels.timeout }}
                </div>
              </ion-col>
              <ion-col size="8">
                <ion-select
                  class="timeout-select text-right text-uppercase body-2"
                  interface="action-sheet"
                  [value]="selectedTimeout || defaultTimeout"
                  (ionChange)="onTimeoutChange($any($event).detail.value)">
                  <ion-select-option
                    *ngFor="let time of upgradeTimeout"
                    [value]="time">
                    <div class="fx-col fx-center p-3 border-box">
                      {{ time }} min
                    </div>
                  </ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
            <!-- Ionic button -->
            <ion-button
              *ngIf="uiFramework === 'ionic'"
              class="upgrade-action-btn tw-mt-4"
              color="primary"
              expand="full"
              [disabled]="!selectedVersion || !selectedTimeout"
              (click)="upgrade.emit({
                selectedTimeout: selectedTimeout,
                selectedVersion: $any(selectedVersion),
                deviceDetails: deviceDetails
              })">
              {{ _labels.updateVersion }}
            </ion-button>
            <!-- Material button -->
            <button
              *ngIf="uiFramework === 'material'"
              mat-raised-button
              color="primary"
              class="upgrade-action-btn-mat tw-mt-4 w-full"
              [disabled]="!selectedVersion || !selectedTimeout"
              (click)="upgrade.emit({
                selectedTimeout: selectedTimeout,
                selectedVersion: $any(selectedVersion),
                deviceDetails: deviceDetails
              })">
              {{ _labels.updateVersion }}
            </button>
          </ion-card-content>
        </ion-row>
      </ng-template>
    </ng-container>
    <ng-template #offline>
      <ion-col size="12">
        <div class="fx-col fx-center p-3 border-box body-2 text-semi-bold text-grey-500">
          {{ offlineLabel }}
        </div>
      </ion-col>
    </ng-template>
  </ion-grid>
</div>

<ng-template
  #label
  let-label="label">
  <ion-item
    class="section-label-item"
    lines="none">
    <span class="section-label-text body-3 text-grey-400 text-400 text-uppercase">
      {{ label }}
    </span>
  </ion-item>
</ng-template>
